import * as React from 'react'
import styles from './index.module.css'

const MetadataNote = (): React.ReactElement<'div'> => (
  <div className={styles.metadataNote}>
    Here you can turn off metadata fields so your recipients won’t see what they
    contain, or you can add metadata just for this playlist. &nbsp;
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://support.disco.ac/home/alias-metadata"
    >
      Find out more about how this works.
    </a>
  </div>
)

export default MetadataNote
